<div class="border-bottom">
  <app-treaty-country-pair-selector
    [selectedCountry] = selectedCountry
    (countryChange) = "onCountryChange($event)"
    (countryTwoChange) = "onCountryTwoChange($event)"
  >

  </app-treaty-country-pair-selector>
</div>


<div class="treaty-other-documents-container">
  <h2>Other Tax Treaty Documents</h2>
  <div class="treaty-other-documents-grid" *ngIf="otherDocuments && otherDocuments.length > 0">
    <div class="slack pointer" *ngFor="let otherDocument of otherDocuments" (click)="onOtherDocumentClicked(otherDocument)">
      <div>
        <div *ngIf="otherDocument.icon" class="icon">
          <i class="{{otherDocument.icon}}"></i>
        </div>

        <div class="title">
          <h3>
            <span>{{otherDocument.groupTitle}}</span>
            <i class="fa-light fa-arrow-up-right-from-square"></i>
          </h3>

        </div>

        <div *ngIf="otherDocument.description" class="description">
          <p>{{otherDocument.description}}</p>
        </div>
      </div>
    </div>
  </div>
</div>

